const PROGRAMMI_BASE_URL = 'https://www.metodofusco.it/tickets';
const STEP_PATHS = {
  questionario: '/#/user-programmi/questionario',
  check_finale: '/#/user-programmi/check-finale',
};

export function buildProgramStepLink({
  stepKey,
  userUid,
  percorsoId,
  stepIndex,
  questionarioDocId,
  questionarioUid,
  questionarioKey,
}) {
  if (!stepKey || !userUid || !percorsoId) return null;
  if (!Number.isFinite(Number(stepIndex))) return null;
  const normalizedIndex = Number(stepIndex);
  const base = PROGRAMMI_BASE_URL.replace(/\/$/, '');
  const path = STEP_PATHS[stepKey] || STEP_PATHS.questionario;
  const params = new URLSearchParams({
    percorsoId,
    stepIndex: String(normalizedIndex),
    stepKey,
    userId: userUid,
  });
  const resolvedDocId = questionarioDocId || questionarioUid || questionarioKey;
  if (resolvedDocId) {
    params.set('questionarioDocId', resolvedDocId);
  }
  return `${base}${path}?${params.toString()}`;
}

export { PROGRAMMI_BASE_URL };
